import {StatsigClient} from '@statsig/js-client'
import {StatsigSessionReplayPlugin} from '@statsig/session-replay';
import {StatsigAutoCapturePlugin} from '@statsig/web-analytics';

export const getStatsigClient = () => {
    const statsigData = JSON.parse(document.getElementById("statsigData").textContent);
    if (!statsigData) {
        return;
    }

    return new StatsigClient(
        "client-OyJfrZURdqRCqy6U23V1wV6hlp4iIKmxCYUeWLwUfI2",
        statsigData?.user,
        {
            plugins: [
                new StatsigSessionReplayPlugin(),
                new StatsigAutoCapturePlugin(),
            ],
            environment: {tier: statsigData?.tier}
        }
    );
}

export const initializeStatsig = () => {
    const statsigClient = getStatsigClient();

    statsigClient.initializeSync();
    // pull the StableID out of the initialized client
    const stableID = statsigClient.getContext().stableID;

    // write it into a cookie so it'll be sent on every request
    document.cookie = [
        `statsig_stable_id=${stableID}`,
        `Path=/`,
        `Max-Age=${60 * 60 * 24 * 365}`, // one year
    ].join('; ');
    // pull the StableID out of the initialized client
    const sessionID = statsigClient.getContext().user.customIDs["Session ID"];

    // write it into a cookie so it'll be sent on every request
    document.cookie = [
        `statsig_session_id=${sessionID}`,
        `Path=/`,
        `Max-Age=${60 * 60 * 24 * 365}`, // one year
    ].join('; ');
}
